<template>
    <div class="footer">
            <div class="row">
                <div class="col-12 col-lg-12 col-sm-12">
                    <div class="row">
                        <div class="col-3 col-lg-3 col-sm-3 stepPaginator">
                            <h6>{{ $t('textTenants.textPagination').replace('{#}', this.numberPage).replace('{$}', numberOfPages) }}</h6>
                        </div>
                        <div class="col-3 col-lg-3 col-sm-3">
                        </div>
                        <div class="col-3 col-lg-3 col-sm-3">
                        </div>
                        <div class="col-3 col-lg-3 col-sm-3 buttonPaginator">
                            <div class="btn-button-container ">
                                <button v-bind:id="this.previousId" class='e-btn' v-bind:class="{ 'e-btn-disable' : this.previousDisabled }"  v-bind:disabled="previousDisabled" v-on:click='btnClicked'>{{ $t('textTenants.textPreviousButton') }}</button>
                            </div>
                            <div class="btn-button-container">
                                <button v-if="!this.save" v-bind:id="this.nextId" class='e-btn' v-bind:class="{ 'e-btn-disable' : this.nextDisabled }" v-bind:disabled="nextDisabled" v-on:click='btnClicked'>{{ $t('textTenants.textNextButton') }}</button>
                                <button v-if="this.save" id="saveButton" class='e-btn'>{{ $t('textTenants.textSaveButton') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import axios from 'axios'
export default {
	name: "create-tenant-footer",
	props: {
        previousId: {default: '',}, 
        nextId: {default: '',}, 
        previousDisabled : {default: false,} , 
        nextDisabled : {default: false,},
        save : {default: false,}, 
        numberPage : {default: 1,}, 
        numberOfPages : {default: 1,}
        },
	methods: {
        btnClicked: function(args) {
            this.$parent.btnClicked(args);
        }

	}
}
</script>